import { ChangeBehavior } from "../ColumnFilterValidated";

export const cnpjChangeHandler: ChangeBehavior = ({ value, setValue }) => {
  return {
    value,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      let v = String(e.target.value ?? "")
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "")
        .slice(0, 14);

      setValue(v);
    },
  };
};